export default __webpack_public_path__ + "static/screenshot-mybiz-5-fa5a298c370e0ac9c2b57ba51de45b42.jpg";